// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"89":"component---src-templates-page-js","197":"75fc9c18","869":"styles"}[chunkId] || chunkId) + "-" + {"89":"53cdb93c87c46fe5a955","197":"bcabcae0296cef3fc273","577":"bf6336d9c4f747bb2b8b","869":"2f11189c44133cd04616"}[chunkId] + ".js";
};